import React from 'react'


import OrderAndEditShared from '../OrderAndEditShared'
import UiContainer from '../../../common-components/UiContainer'


export default UiContainer({
  headerText: 'Order Keg Collars',
  containerId: 'orderKegCollarsSection',
})(
  props => (
    <OrderAndEditShared
      {...props}
      isEditForm={false}
    />
  ),
)
